module.exports = __webpack_public_path__ + "img/service_img11.0549b4ee.png";